import { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"
import { QRCode } from "react-qrcode-logo"
import ReferralMsg from "./ReferralMsg"

export default function Referral({ onClose }) {
  const { fetchReferralDetails, username } = useGlobalContext()
  const [referralData, setReferralData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const playersPerPage = 10

  const totalPlayers = referralData?.l?.players?.length || 0
  const indexOfLastPlayer = currentPage * playersPerPage
  const indexOfFirstPlayer = indexOfLastPlayer - playersPerPage
  const currentPlayers = referralData?.l?.players?.slice(
    indexOfFirstPlayer,
    indexOfLastPlayer
  )
  const [showCopiedMsg, setShowCopiedMsg] = useState(false)

  const handleNext = () => {
    if (currentPage < Math.ceil(totalPlayers / playersPerPage)) {
      setCurrentPage((prev) => prev + 1)
    }
  }

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1)
    }
  }

  useEffect(() => {
    const getReferralData = async () => {
      if (username) {
        try {
          const data = await fetchReferralDetails(username)
          setReferralData(data)
        } catch (err) {
          setError(err)
        } finally {
          setLoading(false)
        }
      } else {
        setLoading(false)
      }
    }
    getReferralData()
  }, [username, fetchReferralDetails])

  // Ensure the referral URL includes a domain name.
  const getFullReferralUrl = (url) => {
    // If the url already starts with http or https, return it as is.
    if (url && (url.startsWith("http://") || url.startsWith("https://"))) {
      return url
    }

    const domain = window.location.origin
    return url ? `${domain}${url}` : ""
  }

  const referralUrl = getFullReferralUrl(referralData?.url)

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(referralUrl)
      .then(() => {
        setShowCopiedMsg(true)
        setTimeout(() => setShowCopiedMsg(false), 1000)
      })
      .catch(() => {
        // Optional: you can render a failure message similarly
        alert("Failed to copy.")
      })
  }

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const formatDate = (rawDate) => {
    if (!rawDate) return ""

    const year = rawDate.toString().slice(0, 4)
    const month = rawDate.toString().slice(4, 6)
    const day = rawDate.toString().slice(6, 8)

    const date = new Date(`${year}-${month}-${day}`)

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }) // Example output: Jan 07, 2024
  }

  const handleCloseMsg = () => {
    setShowCopiedMsg(false)
  }
  return (
    <>
      <div className="openProfileItems-container">
        {" "}
        {showCopiedMsg && (
          <div className="referral-msg-container">
            <ReferralMsg onClose={handleCloseMsg} />
          </div>
        )}
        {windowWidth <= 840 && (
          <>
            <div className="close-profile-module-container">
              <div className="profile-logo">
                <a href="/">
                  <img src="/images/icon/fgh-logo.webp" alt="" />
                </a>
              </div>
              <button className="close-profile-module-btn" onClick={onClose}>
                <img src="/images/icon/ARROW.webp" alt="" /> Back
              </button>
            </div>
          </>
        )}
        <div className="openReferral">
          <div className="openProfile-Label">Referral Program</div>
          <div className="referral-headline">
            {referralUrl && (
              <div className="referral-qr-code">
                <QRCode
                  value={referralUrl}
                  size={140}
                  logoImage="/images/fav.webp"
                  logoWidth={40}
                  logoHeight={40}
                  logoOpacity={1}
                  removeQrCodeBehindLogo={true}
                />
              </div>
            )}
            <div className="referral-details">
              <div className="referral-detail-id">
                <label>Referral ID:</label> <span>{username}</span>
              </div>
              <div className="referral-detail-link">
                <label>Referral Link: </label>
                <div className="referral-input-container">
                  <input
                    type="text"
                    value={referralUrl}
                    readOnly
                    onFocus={(e) => e.target.select()}
                  />
                </div>
                <button className="referral-copy-btn" onClick={handleCopyLink}>
                  Copy Link
                </button>
              </div>
            </div>
          </div>
          <div className="refferal-content">
            <div className="referral-active">
              <div className="referral-content-label">Active Players</div>
              <div className="referral-active-player-data">
                <div className="refferal-content-thead">Username</div>
                {referralData?.l?.players &&
                referralData.l.players.length > 0 ? (
                  <>
                    <div className="refferal-content-results">
                      {currentPlayers.map((player, index) => (
                        <div key={index}>{player}</div>
                      ))}
                    </div>
                    <div
                      className="pagination-buttons"
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <button onClick={handlePrev} disabled={currentPage === 1}>
                        Previous
                      </button>
                      <span>
                        Page {currentPage} of{" "}
                        {Math.ceil(totalPlayers / playersPerPage)}
                      </span>
                      <button
                        className=""
                        onClick={handleNext}
                        disabled={
                          currentPage >=
                          Math.ceil(totalPlayers / playersPerPage)
                        }
                      >
                        Next
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="referral-no-data">No Data Found</div>
                )}
              </div>
            </div>
            <div className="commission-content">
              <div className="referral-content-label">Latest Commission</div>
              <div className="commission-content-table">
                <div className="commission-content-thead">
                  <div>Date</div>
                  <div>Commission</div>
                </div>
                {referralData?.latestCommission?.dates?.length > 0 ? (
                  <div className="commission-content-body">
                    {referralData.latestCommission.dates.map((date, index) => (
                      <div key={index} className="commission-content-results">
                        <div>{formatDate(date)}</div>
                        <div>
                          {referralData.latestCommission.commissions[index]}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="referral-no-data">No Data Found</div>
                )}
              </div>
            </div>
          </div>
          {error && <div className="error">Error: {error.message}</div>}
          {loading && (
            <div className="loading">Loading referral details...</div>
          )}
        </div>
      </div>
    </>
  )
}
